'use strict';
/**
 * @ngdoc function
 * @name thothAppApp.directive:tooltip
 * @description
 * # tooltip
 * Directive to show tooltips
 */
angular.module('thothApp.directives')
.directive('tooltip', function(){
  return {
    restrict: 'A',
    link: function(scope, element){
      $(element).hover(function(){
        // on mouseenter
        $(element).tooltip('show');
      }, function(){
        // on mouseleave
        $(element).tooltip('hide');
      });
    }
  };
});
